import * as _ from "lodash";
import PropTypes from "prop-types";
import { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

import actions from "@/actions";
import { Form, Tabs } from "@/components";

import { Ceiling, Fixture, GeoTransform, Space } from "./tabs";

const MapSettingsEdit = ({
    mapSettings,
    save,
    deselectAllLights,
    toggleVisibility,
}) => {
    const [settings, setSettings] = useState(mapSettings);
    const settingsFormRef = useRef(null);

    const onSettingsChanged = useCallback((settingsId, newSettings) => {
        setSettings((prevSettings) => {
            // Use the class setter to maintain getters/setters
            prevSettings[settingsId] = {
                ...prevSettings[settingsId],
                ...newSettings,
            };
            // Return the same instance to trigger re-render
            return Object.assign(
                Object.create(Object.getPrototypeOf(prevSettings)),
                prevSettings,
            );
        });
    }, []);

    useEffect(() => {
        settingsFormRef.current?.validate();
    }, [settings]);

    const onValidateForm = useCallback((controls, model) => {
        let isValid = true;
        _.forEach(controls, (control) => {
            const controlPath = control.name.split("-");
            const section = model[controlPath[0]];
            if (!section) return;
            const value = section[controlPath[1]];
            if (!control.validate(value)) {
                isValid = false;
            }
        });
        return isValid;
    }, []);

    const handleSave = useCallback(() => {
        save(settings);
        deselectAllLights();
    }, [save, settings, deselectAllLights]);

    const getTabProps = useCallback(
        (title) => {
            const id = _.camelCase(title);
            return {
                name: id,
                key: _.kebabCase(`${title}-tab`),
                model: settings[id],
                onChangeState: (state) => onSettingsChanged(id, state),
            };
        },
        [settings, onSettingsChanged],
    );

    const createTab = (title, component) =>
        Tabs.createTab(title, component, getTabProps(title));

    const SettingsTabs = [
        createTab("Space Details", Space),
        createTab("Ceiling Details", Ceiling),
        createTab("Fixture Details", Fixture),
        createTab("GeoTransform", GeoTransform),
    ];

    return (
        <Form
            ref={settingsFormRef}
            model={settings}
            onValidate={onValidateForm}
            onSubmit={handleSave}
            onCancel={toggleVisibility}
        >
            <Tabs>{SettingsTabs}</Tabs>
        </Form>
    );
};

MapSettingsEdit.propTypes = {
    mapSettings: PropTypes.any,
    save: PropTypes.func,
    deselectAllLights: PropTypes.func,
    toggleVisibility: PropTypes.func,
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
    toggleVisibility: actions.map.general.toggleSettingsVisibility,
};

export default connect(mapStateToProps, mapDispatchToProps)(MapSettingsEdit);
